import changelogData from './changelog.json';

export const CURRENT_VERSION = changelogData.currentVersion;
export const CHANGELOG = changelogData.entries;
